import {
  Button, Card, CardActions, CardContent, CardHeader, Divider, Modal, Snackbar
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import AddIcCallIcon from '@material-ui/icons/AddIcCall';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { deviceType } from 'react-device-detect';
import { connect } from 'react-redux';
import Alert from 'src/components/Alert';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 700,
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  actions: {
    justifyContent: 'flex-end'
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%'
  }
}));
function FgsArama({
  open, onClose, ReceiptNo, tasks, className, ...rest
}) {
  const classes = useStyles();
  const [LoadingControl, setLoadingControl] = useState(false);
  const [responseMessage, setresponseMessage] = useState({ ErrorCode: '0', ErrorDescription: 'İşleminiz başarı ile gerçekleştirildi.' });
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  const { t } = useTranslation('overview');
  let AramaData = [];
  if (ReceiptNo === '') {
    return null;
  }
  if (tasks.tasks !== '') {
    AramaData = tasks.tasks.filter((d) => parseInt(d.ReceiptNo) === parseInt(ReceiptNo));
  }

 

  if (!open) {
    return null;
  }

  const SessionUser = getUser();

  const handleFgsAramaYap = (event, CustomerFullName, Telefon, lblAramaUyari) => {
    const Uyari = `${CustomerFullName} - ${Telefon} ${lblAramaUyari}`;
    const confirmation = window.confirm(Uyari);
    if (!confirmation) {
      return;
    }
    const phoneNumber = Telefon;
    window.open(`tel:${phoneNumber}`, '_self');
  };


  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const handleOnTitlePhoneClick = () => {


  };

  const AramaTitle = ({ aramaData }) => (
    <>
      <div>
        {`${aramaData[0].ReceiptNo} ${aramaData[0].CustomerFullName} ${aramaData[0].IssueReason}`}
      </div>
    </>
  );


  return (
    <Modal
      onClose={onClose}
      open={open}
    >
      <Card className={clsx(classes.root, className)}>
        <form>
          <CardHeader title={<AramaTitle aramaData={AramaData} />} />
          <Divider />
          <CardContent>
            {
              LoadingControl
                ? (
                  <CircularProgress
                    status="loading"
                    style={{ marginLeft: '50%' }}
                  />
                )
                : <div />
            }
            <div>
              <div className={classes.wrapper}>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.submitButton}
                  onClick={(event) => handleFgsAramaYap(event, AramaData[0].ContactName, AramaData[0].ContactPhone.substring(2, AramaData[0].ContactPhone.length), t('lblAramaUyari'))}
                  endIcon={<AddIcCallIcon>Call</AddIcCallIcon>}
                >
                  {AramaData[0].ContactName}
                  {' '}
                  :
                  {AramaData[0].ContactPhone.substring(2, AramaData[0].ContactPhone.length)}
                </Button>
              </div>
              {AramaData[0].ConsumerPhones.map((item) => (
                <div className={classes.wrapper} key={item.Phone}>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.submitButton}
                    onClick={(event) => handleFgsAramaYap(event, AramaData[0].CustomerFullName, item.Phone, t('lblAramaUyari'))}
                    endIcon={<AddIcCallIcon>Call</AddIcCallIcon>}
                  >
                    {item.Type}
                    {' '}
                    :
                    {item.Phone}
                  </Button>
                </div>
              ))}
            </div>
            <Snackbar open={uyari} onClose={uyariKapat} autoHideDuration={5000}>
              <Alert onClose={uyariKapat} message={responseMessage.ErrorDescription} variant={uyariTip} />
            </Snackbar>
          </CardContent>
          <Divider />
          <CardActions className={classes.actions}>
            <Button
              variant="contained"
              color="primary"
              onClick={onClose}
            >
              {t('Ok')}
            </Button>
          </CardActions>
        </form>
      </Card>
    </Modal>
  );
}

FgsArama.propTypes = {
  className: PropTypes.string,
  ReceiptNo: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool
};

FgsArama.defaultProps = {
  open: false,
  onClose: () => { }
};

export default connect(
  (state) => ({ tasks: state.tasks1 })
)(FgsArama);
